import React from 'react'
import {Container, Row, Col} from 'reactstrap';
import {formatLocalNumber} from '../utils/Strings'

export default class SalesRowDetails extends React.Component{
  
//  handleReserve(idx){
//    //alert(idx)
//    this.props.onCourseChoose(idx)
//  }
 
  render() {
    var r=this.props.data;
    
    if (r != null){
      return (          
        <Container fluid={true} className="defListDetails" >  
        <Row >          
          <Col xs="4" >
          <div className="detailColHeader left">Przewoźnik</div>        
          </Col>
                  
          <Col xs="2" >        
          <div className="detailColHeader right">Sprzedaż</div>
          <div className="detailExtras right">Netto/VAT</div>
          </Col>
          
          <Col xs="2" >
          <div className="detailColHeader right">Zwroty</div>
          <div className="detailExtras right">Netto/VAT</div>
          </Col>  
          
          <Col xs="2" >        
          <div className="detailColHeader right">Bilans</div>
          <div className="detailExtras right">Netto/VAT</div>
          </Col>        
          
          <Col xs="2" >        
          <div className="detailColHeader right">Potr. zwr.</div>          
          <div className="detailExtras right">zwr. agenta</div>
          </Col>        
        </Row>         
        {Object.keys(r).map((item, i) => (
          <Row key={i} title={r[item].fullName} >        
            <Col xs="4" >
            <div >{r[item].name}</div>        
            </Col>
                    
            <Col xs="2" >
            <div className="detailImp right">{formatLocalNumber(r[item].sale)}</div>
            <div className="detailExtras right">{formatLocalNumber(r[item].saleNetto)} /{formatLocalNumber(r[item].saleVat)}</div>
            </Col>
            
            <Col xs="2" >
            <div className="detailImp right">{formatLocalNumber(r[item].refund)}</div>
            <div className="detailExtras right">{formatLocalNumber(r[item].refundNetto)} /{formatLocalNumber(r[item].refundVat)}</div>
            </Col>     
            
            <Col xs="2" >
            <div className="detailImp right">{formatLocalNumber(r[item].sale - r[item].refund)}</div>
            <div className="detailExtras right">{formatLocalNumber(r[item].saleNetto - r[item].refundNetto)} /{formatLocalNumber(r[item].saleVat - r[item].refundVat)}</div>
            </Col>        

            <Col xs="2" >
            <div className="detailImp right">{formatLocalNumber(r[item].refundDeduction)}</div>            
            <div className="detailExtras right">{formatLocalNumber(r[item].refundAgent)}</div>
            </Col>        
          </Row>  
          )
        )}

           
        </Container>
      )
  }
  else
    return (
      <p>---</p>
    )
    
  }
}


// WEBPACK FOOTER //
// ./src/components/SalesRowDetails.js